import { Action, Dispatch } from "redux";
import { PAGE_TYPE } from "../pages/page.types";
import fetchContentByRoute from "../helpers/fetchContentByRoute";
import isBrowserContext from "helpers/isBrowserContext";

export const UPDATE_PAGE = "UPDATE_PAGE";

export interface UpdatePageAction extends Action {
    type: typeof UPDATE_PAGE;
    content: PAGE_TYPE;
    statusCode: number;
    redirectUrl?: string;
}

export const thunkUpdatePage = (url: string, history?: any) => async (dispatch: Dispatch): Promise<void> => {
    try {
        if (!url) {
            throw new Error();
        }

        const pageResponse = await fetchContentByRoute(url);

        if ((pageResponse.result?.umbracoRedirect || pageResponse.redirectUrl) && isBrowserContext()) {
            window.location.href = pageResponse.result?.umbracoRedirect ?? pageResponse.redirectUrl ?? "/";
        }
        else if (typeof (pageResponse.result) !== "undefined") {
            const action: UpdatePageAction = {
                type: UPDATE_PAGE,
                content: pageResponse.result,
                statusCode: pageResponse.statusCode,
                redirectUrl: pageResponse.result.umbracoRedirect
            };

            if (typeof (history) !== "undefined") {
                history.replace({
                    pathname: history.location.pathname,
                    search: history.location.search,
                    hash: history.location.hash,
                    state: {
                        ...history.location.state,
                        page: pageResponse.result
                    }
                });
            }

            dispatch(action);
        }
    }
    catch {
        // TODO: Retry loading the page every 2 seconds

        const action: UpdatePageAction = {
            type: UPDATE_PAGE,
            content: {
                _contentType: "errorPage",
                _name: "500 - An error occured",
                _url: url
            },
            statusCode: 500
        };

        dispatch(action);
    }
};

export type PageAction = UpdatePageAction;
